


import { useEffect, useRef } from "react";

const WS_URL = process.env.REACT_APP_WS_URL;
const MAX_VIOLATIONS = 3;

export const useVivaSecurity = (
  ee_id,
  onForceSubmit,
  setViolationOpen,
  setViolationMessage,
  setViolationCount,
  //  setShowSubmitDialog 
) => {
  const socketRef = useRef(null);
  const queueRef = useRef([]);

  const flushQueue = () => {
    while (queueRef.current.length > 0) {
      socketRef.current.send(
        JSON.stringify(queueRef.current.shift())
      );
    }
  };
  const forceSubmitRef = useRef(false);


  // 🔥 SAME LOGIC AS EXAM.JS
  const triggerViolation = (type, message) => {
    setViolationCount((prev) => {
          if (forceSubmitRef.current) return prev;
      const next = prev + 1;

      

     if (next <= MAX_VIOLATIONS) {
      setViolationMessage(message);
      setViolationOpen(true);
    }

    // 2️⃣ Third violation → submit dialog ONLY
    if (next>= MAX_VIOLATIONS) {
      setViolationOpen(false);
      forceSubmitRef.current = true;
      onForceSubmit("malpractice"); // 🔒 ONLY responsibility
    }

      return next;
    });

    // backend logging (async)
    sendViolation(type);
  };

  const sendViolation = (type) => {
    const payload = {
      action: "violation",
      payload: { type },
    };

    const socket = socketRef.current;

    if (!socket || socket.readyState !== WebSocket.OPEN) {
      queueRef.current.push(payload);
      return;
    }

    socket.send(JSON.stringify(payload));
  };

  useEffect(() => {
    socketRef.current = new WebSocket(
      `${WS_URL}/ws/viva-security/${ee_id}/`
    );
    console.log("connected web socket")

    socketRef.current.onopen = flushQueue;

    socketRef.current.onmessage = (e) => {
      const data = JSON.parse(e.data);

      if (data.action === "force_submit") {
        onForceSubmit(data.reason || "malpractice");
      }
    };

    return () => socketRef.current?.close();
  }, [ee_id]);

  return { triggerViolation };
};
